const utils = {
    moneyFormat: function (money, currency = "CAD") {
        return `${currency}${(parseInt(money) / 100).toFixed(2)}`
    },
    dateFormat: {
        slashDateFormat: function (date) {
            return date.replace("-", "/")
        },
        dashDateFormat: function (date) {
            return date.replace("/", "-")
        }
    },
    elementPosition: function (element) {
        var rect = element.getBoundingClientRect();
        return { top: rect.top, right: rect.right, bottom: rect.bottom, left: rect.left }
    },
    scrollElementToTop: function (element) {
        const header_position = utils.elementPosition(document.querySelector("header"))
        const init_position = utils.elementPosition(element)

        var retries = 0;
        var direction = 4
        if (init_position.top < header_position.bottom) {
            direction = direction * -1
            const interval = setInterval(function () {
                retries++;
                const position = utils.elementPosition(element)
                if (position.top < header_position.bottom) {
                    window.scrollBy(0, direction)
                } else {
                    clearInterval(interval)
                }

                if (retries >= 2000) {
                    clearInterval(interval)
                }
            }, 1)
        } else {
            const interval = setInterval(function () {
                retries++;
                const position = utils.elementPosition(element)
                if (position.top > header_position.bottom) {
                    window.scrollBy(0, direction)
                } else {
                    clearInterval(interval)
                }

                if (retries >= 2000) {
                    clearInterval(interval)
                }
            }, 1)
        }
    }
}

const globalFunctions = {
    fetchProduct: async function (handle) {
        const response = await window.fetch(`/products/${handle}.js`)
        const data = await response.json()
        return data;
    },
    fetchProductRecommendation: async function (id, limit) {
        try {
            const response = await window.fetch(`/recommendations/products.json?product_id=${id}&limit=${limit}`)
            const data = await response.json()
            return data;
        } catch (err) { return console.log(err) }
    },
    fetchSection: async function (sectionsIDs) {
        const response = await fetch("/?sections=" + sectionsIDs.toString())
        const sections = await response.json()
        return sections;
    },
    renderSections: function (section, targeElement) {
        targeElement.innerHTML = section
    },
    populateElement: async (sectionsIDs, targeElement) => {
        const sections = await this.fetchSection(sectionsIDs)
        if (sections.length != 0) {
            return this.renderSections(sections, targeElement)
        } else {
            return this.renderSections("Sorry, we are facing a problem. Please try again in a second", targeElement)
        }
    },
    updateFreeShippingBar: (cartSubtotal) => {
        const percentage = (parseInt(cartSubtotal) / 50) * 100
        const missing = percentage < 100 ? utils.moneyFormat((18000 - cartSubtotal), "$") : ""
        document.querySelectorAll(".progress-bar").forEach((el) => {
            el.style.width = `${percentage}%`
        })
        if (percentage < 100) {
            document.querySelectorAll(".missing-for-free-shipping").forEach((el) => {
                el.innerText = `${missing}`
            })
        } else {
            document.querySelectorAll(".missing-for-free-shipping").forEach((el) => {
                el.style.display = "none"
            })
            document.querySelectorAll(".free-shipping-top-text").forEach((el) => {
                el.innerText = "🎉 Congrats! You've unlocked FREE SHIPPING!"
            })
            document.querySelectorAll(".free-shipping-success").forEach((el) => {
                el.innerText = "You've unlocked FREE SHIPPING!"
            })
        }
    }
}

const trackEvents = {
    addToCart: function () {
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'Add To Cart']);
    },
    checkout: function () {
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'Checkout']);
    },
    thankYouPage: function () {
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'Thank You Page']);
    },
    cartUpsell: function () {
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'Cart Upsell']);
    },
    blogUpsell: function () {
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'Blog Upsell']);
    }
}

const cartHandler = {
    getCart: async function () {
        try {
            const response = await fetch('/cart.js')
            if (response.ok) {
                return await response.json()
            } else {
                return { error: response }
            }
        } catch (err) {
            return console.log({ error: err })
        }
    },
    clearCart: async function () {
        try {
            const current_cart = await this.getCart()
            const attributes = {}
            for (const attribute in current_cart.attributes) {
                console.log(attribute)
                attributes[attribute] = ""
            }
            const body = JSON.stringify({ attributes })
            const response = await fetch(`${routes.cart_clear_url}`, { ...fetchConfig() })
            const response2 = await fetch('/cart/update.js', { ...fetchConfig(), ...{ body } })
            if (response.ok && response2.ok) {
                const data1 = await response.json()
                const data2 = await response2.json()
                return { data1, data2 }
            } else {
                return { error: response }
            }
        } catch (err) { console.log(err) }
    },
    changeCart: async function ({ line, quantity, sections = ["cart-icon-bubble"] }) {
        const data = { line, quantity, sections }
        const body = JSON.stringify(data)
        try {
            const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            if (response.ok) {
                return await response.json()
            } else {
                return { error: response }
            }
        } catch (err) { console.log(err) }
    },
    updateCartItem: async function ({ variant_id, quantity, sections = ["cart-icon-bubble"] }) {
        console.log({ variant_id, quantity, sections })
        const updates = {}
        updates[variant_id] = quantity
        const data = { updates, sections }
        const body = JSON.stringify(data)
        try {
            const response = await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
            if (response.ok) {
                return await response.json()
            } else {
                return { error: response }
            }
        } catch (err) { console.log(err) }
    },
    bulkAddToCart: async (body) => {
        try {
            const response = await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body: JSON.stringify(body) } })
            if (response.ok) {
                trackEvents.addToCart()
                return await response.json()
            } else {
                return { error: response }
            }
        } catch (err) { console.log(err) }
    },
    addToCart: async function ({ variant_id, quantity, selling_plan_id = "", sections = ["cart-icon-bubble"] }) {
        const data = {
            items: [{
                id: variant_id,
                quantity: quantity,
                selling_plan: selling_plan_id
            }],
            sections: sections,
            sections_url: '/cart'
        };
        const body = JSON.stringify(data)
        try {
            const response = await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
            if (response.ok) {
                trackEvents.addToCart()
                return await response.json()
            } else {
                return { error: response }
            }
        } catch (err) { console.log(err) }
    },
    addWithSellingPlan: async function ({ variant_id, selling_plan_id = "", quantity }) {
        const searchLineItemInCart = async (variant_id) => {
            const cart = await cartHandler.getCart()
            const line_item = {}
            if (cart.items.length > 0) {
                cart.items.forEach((item, index) => {
                    if (item.variant_id == variant_id) {
                        line_item["item"] = item
                        line_item["line"] = Number(index + 1)
                        return line_item;
                    }
                })
            } else {
                return null;
            }
        }
        const line_item = await searchLineItemInCart(variant_id) || null
        if (line_item) {
            if (line_item.selling_plan_allocation) {
                const addToCart = await this.changeCart({ line: line_item.line, quantity })
                return addToCart
            } else {
                // to add Selling Plan we have to remove the item and add again with add.js endpoint passing the selling_plan_id
                const removeItem = await this.changeCart({ line: line_item.line, quantity: 0 })
                console.log({ removeItem })
                if (removeItem) {
                    const addToCart = await this.addToCart({ variant_id, selling_plan_id, quantity })
                    return addToCart
                } else {
                    return { error: removeItem }
                }
            }
        } else {
            const addToCart = await this.addToCart({ variant_id, selling_plan_id, quantity })
            return addToCart
        }
        trackEvents.addToCart()
    }
}

function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
document.addEventListener("DOMContentLoaded", async function () {
    await delay(1000)
    const openChatButtons = document.querySelectorAll("a[href='#open-chat']")
    const shopifyChat = document.querySelector("#dummy-chat-button-iframe")
    const zohoChat = document.querySelector("#zsiq_float")
    if (openChatButtons.length == 0) return
    openChatButtons.forEach((el) => {
        el.addEventListener("click", function (e) {
            e.preventDefault()
            if (shopifyChat) shopifyChat.click()
            if (zohoChat) zohoChat.click()
        })
    })
})